/**
 * useFeatureAccess — check the signed-in user's feature switches in a component.
 *
 *   const allowed = useFeatureAccess();
 *   {allowed(FEATURES.DELETE_PORTFOLIO) ? <Button>Delete Portfolio</Button> : null}
 *
 * Returns a checker over the auth slice's feature branch (security/features.js
 * holds the rule). The checker is stable while the data is, so it is safe in
 * dependency lists. Hide what is not allowed — legacy's v-permission removes
 * the element rather than disabling it.
 */
import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { selectFeatures } from '@security/auth/authSlice';
import { isFeatureEnabled } from '@security/features';

export function useFeatureAccess() {
  const branch = useSelector(selectFeatures);
  return useCallback((key) => isFeatureEnabled(branch, key), [branch]);
}
